import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { LiveProvider } from "@/contexts/LiveContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import BottomNav from "@/components/BottomNav";
import GuestAuthPill from "@/components/GuestAuthPill";
import PageTransition from "@/components/PageTransition";
import SplashScreen from "@/components/SplashScreen";
import HomePage from "@/components/HomePage";
import IssueDetail from "@/components/IssueDetail";
import UserProfile from "@/components/UserProfile";
import AdminPanel from "@/components/AdminPanel";
import AuthCallback from "@/components/AuthCallback";
import "@/App.css";

function AppContent() {
  const location = useLocation();
  const ref = new URLSearchParams(location.search).get("ref");
  if (ref) localStorage.setItem("fv_ref", ref);
  if (location.hash?.includes('session_id=')) return <AuthCallback />;

  return (
    <div className="min-h-screen bg-bg">
      <SplashScreen />
      <Navbar />
      <main className="pb-20 lg:pb-0">
        <PageTransition>
          <Routes location={location}>
            <Route path="/" element={<HomePage />} />
            <Route path="/issue/:topicId" element={<IssueDetail />} />
            <Route path="/profile/:userId" element={<UserProfile />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </PageTransition>
      </main>
      <BottomNav />
      <GuestAuthPill />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <LiveProvider>
            <AppContent />
            <Toaster position="top-center" />
          </LiveProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
